<!-- 巨量广告-新建项目 -->
<template>
<div style="display: flex;justify-content: space-between;background: radial-gradient(100% 158.63% at 0% 0%,rgba(217,242,255,.3) 0%,rgba(242,240,252,.3) 30.21%,rgba(191,216,255,.3) 100%);margin: -20px -30px -30px;padding: 20px 30px;">
	<div style="margin-right: 20px;background-color: #fff;padding: 20px 30px;position: sticky;top: 85px;height: calc(100vh - 125px);width: 200px;">
		<div style="display: flex;align-items: center;height: 40px;">
			<div style="background-color: #2a55e5;height: 20px;width: 20px;color: #fff;border-radius: 50%;text-align: center;line-height: 20px;">1</div>
			<div style="margin-left: 10px;font-weight: 600;color: #2a55e5;">项目</div>
		</div>
		<div @click="clickMenu('#yxmb')" class="label-box" style="color: #2a55e5;">
			<div class="label-icon-true"></div>
			<div>营销目标与场景</div>
		</div>
		<div @click="clickMenu('#glcp')" class="label-box">
			<div class="label-icon"></div>
			<div>关联产品投放</div>
		</div>
		<div @click="clickMenu('#tfnr')" class="label-box">
			<div class="label-icon"></div>
			<div>投放内容与目标</div>
		</div>
		<div @click="clickMenu('#tfbw')" class="label-box">
			<div class="label-icon"></div>
			<div>投放版位</div>
		</div>
		<div @click="clickMenu('#yhdx')" class="label-box">
			<div class="label-icon"></div>
			<div>用户定向</div>
		</div>
		<div @click="clickMenu('#pqys')" class="label-box">
			<div class="label-icon"></div>
			<div>排期与预算</div>
		</div>
		<div @click="clickMenu('#sskt')" class="label-box">
			<div class="label-icon"></div>
			<div>搜索快投</div>
		</div>
		<div @click="clickMenu('#jclj')" class="label-box">
			<div class="label-icon"></div>
			<div>监测链接</div>
		</div>
		<div @click="clickMenu('#xmmc')" class="label-box">
			<div class="label-icon"></div>
			<div>项目名称</div>
		</div>
		
	</div>
	<div style="width: calc((100vw - 350px)*0.9);padding: 30px;background-color: #fff;">
		<div id="yxmb" class="modul-title"> 营销目标与场景 </div>
		<marketing-info
		    :cur-value="marketing_info_curValue"
			@receive="MarketingInfoReceive"
		/>
		
		<div id="glcp" class="modul-title"> 关联产品投放 </div>
		<div class="div-box">暂无</div>
		
		<div id="tfnr" class="modul-title"> 投放内容与目标 </div>
		<div class="div-box">暂无</div>
		
		<div id="tfbw" class="modul-title"> 投放版位 </div>
		<div class="div-box">暂无</div>
		
		<div id="yhdx" class="modul-title"> 用户定向 </div>
		<audience-target @receive="receive" :curValue="curValue" :extensions="{}"/>
		
		<div id="pqys" class="modul-title"> 排期与预算 </div>
		<BudgetSchedule
		:cur-value="BudgetSchedule_curValue"
		:extensions="BudgetSchedule_extensions"
		@receive="BudgetScheduleReceive"
		/>
		
		<div id="sskt" class="modul-title"> 搜索快投 </div>
		<div class="div-box">暂无</div>
		
		<div id="jclj" class="modul-title"> 监测链接 </div>
		<div class="div-box">暂无</div>
		
		<div id="xmmc" class="modul-title"> 项目名称 </div>
		<div class="div-box">暂无</div>
	</div>
	<div style="width: 150px;"></div>
</div>
</template>

<script>
import { MarketingInfo } from '@bytedance-ad/mui-vue2';
import { BudgetSchedule } from '@bytedance-ad/mui-vue2';
export default {
	name: 'jlCreateProject_',
	data() {
		return {
			menuData: [{
				title: "",
			}],
			
			marketing_info_curValue : {},
			curValue: { },
			
			BudgetSchedule_curValue: { 
				schedule_type: 'SCHEDULE_FROM_NOW',
				bid_type: 'CUSTOM',
				budget_mode: 'BUDGET_MODE_INFINITE'
			},
			BudgetSchedule_extensions: { delivery_mode: 'PROCEDURAL' },
			
		}
	},
	components: {
	    MarketingInfo, BudgetSchedule,
	},
	mounted(){
		
	},
	methods: {
		MarketingInfoReceive(value) {
		        this.marketing_info_curValue = value
		},
		receive(value) {
			console.log("value",value);
		    this.curValue = value
		},
		BudgetScheduleReceive(value) {
		      // 不可缺少这一步
		      this.curValue = value
		},
		
		clickMenu(id_){
			let pageId = document.querySelector(id_);
			// console.log("pageId",pageId);
			// console.log("pageId.offsetTop",pageId.offsetTop);
			window.scrollTo({
				top: pageId.offsetTop - 90, //y 上线
				left:0,//x 左右
				behavior:'smooth',//属性值：默认值auto（相当于instant）、平滑滚动smooth、瞬间滚动instant
			});
			
		}
	},
}
</script>

<style scoped>
.modul-title {
	color: #323335;
	font-size: 20px;
	font-weight: 600;
	line-height: 28px;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.div-box {
	width: 100%;
	height: 200px;
}
.label-box {
	display: flex;
	align-items: center;
	height: 40px;
	padding-left: 15px;
	margin: 8px 0;
	cursor: pointer;
}
.label-icon {
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background-color: #64666B;
	margin-right: 12px;
}
.label-icon-true {
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background-color: #2a55e5;
	margin-right: 12px;
}
.label-box:hover .label-icon{
	background-color: #2a55e5;
}
.label-box:hover {
	color: #2a55e5;
}
</style>